/**
 * El mapa de tipos de pregunta.
 *
 * Es la otra mitad del principio VII: junto con el módulo de cada tipo, el único sitio donde un
 * identificador concreto puede aparecer. El resto del sistema —el editor, el motor de partida, la
 * importación— pasa siempre por aquí.
 *
 * El `satisfies` hace que **olvidarse de registrar un tipo no compile**: si se añade un
 * identificador a `QUESTION_TYPE_IDS` sin su entrada, TypeScript lo rechaza. Y la intersección con
 * la clave impide registrar un tipo bajo el identificador de otro.
 */
import { QUESTION_TYPE_IDS } from './contract.js';
import { multipleChoice } from './multiple-choice.js';
export const QUESTION_TYPES = {
    multiple_choice: multipleChoice,
};
/**
 * Devuelve el módulo de un tipo.
 *
 * Quien llama trae un identificador ya validado; para una cadena cualquiera venida de fuera está
 * `isQuestionTypeId`.
 */
export function questionTypeOf(id) {
    return QUESTION_TYPES[id];
}
/** Todos los tipos registrados, en el orden en que se declararon. */
export function allQuestionTypes() {
    return QUESTION_TYPE_IDS.map((id) => QUESTION_TYPES[id]);
}
/**
 * El tipo con el que nace una pregunta nueva: el primero de la lista.
 *
 * Existe para que el editor no tenga que escribir ningún identificador ni indexar la lista a
 * mano. Es la diferencia entre «el editor conoce un tipo» y «el editor pregunta al registro»,
 * que es justo lo que separa el principio VII de un condicional disfrazado.
 */
export function defaultQuestionTypeId() {
    return QUESTION_TYPE_IDS[0];
}
//# sourceMappingURL=registry.js.map